import { sortChildren as o } from "../utils/vnodes.js";
function u(e, t) {
  var n, d;
  t === void 0 && (t = {});
  var a = t.indexKey || "index";
  return {
    inject: (n = {}, n[e] = {
      default: null
    }, n),
    computed: (d = {
      parent: function parent() {
        return this.disableBindRelation ? null : this[e];
      }
    }, d[a] = function () {
      return this.bindRelation(), this.parent ? this.parent.children.indexOf(this) : null;
    }, d),
    watch: {
      disableBindRelation: function disableBindRelation(i) {
        i || this.bindRelation();
      }
    },
    mounted: function mounted() {
      this.bindRelation();
    },
    beforeDestroy: function beforeDestroy() {
      var i = this;
      this.parent && (this.parent.children = this.parent.children.filter(function (h) {
        return h !== i;
      }));
    },
    methods: {
      bindRelation: function bindRelation() {
        if (!(!this.parent || this.parent.children.indexOf(this) !== -1)) {
          var i = [].concat(this.parent.children, [this]);
          o(i, this.parent), this.parent.children = i;
        }
      }
    }
  };
}
function c(e) {
  return {
    provide: function provide() {
      var n;
      return n = {}, n[e] = this, n;
    },
    data: function data() {
      return {
        children: []
      };
    }
  };
}
export { u as ChildrenMixin, c as ParentMixin };
